module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    style: (_vm.heightStyle),
    attrs: {
      "src": _vm.attr.url
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-449a479e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/sgs/SgsRenderImage.vue
// module id = 918
// module chunks = 2